import api from '@/api';
import { get, post } from '@/utils/http';
import { isCustomerSaasPrivate } from '@/utils/globalConfig';
const getAbsolutePathIfExists = (arr) => {
  if (Array.isArray(arr) && arr.length > 0) {
    // eslint-disable-next-line no-prototype-builtins
    const itemWithAbsolutePath = arr.find((item) => item.hasOwnProperty('absolutePath'));
    if (itemWithAbsolutePath) {
      return itemWithAbsolutePath.absolutePath;
    }
  }
  return '';
}

// 接口文档 https://yapi.znlh.work/project/430/interface/api/119459
const getDisposition = async () => {
  localStorage.removeItem('uiInfo');
  // 获取登录所有配置，存到本地缓存
  try {
   const res = await get(api.getAllUiInfo, { domainUrl: window.location.hostname.toString() });
   //   const res = await get(api.getAllUiInfo, { domainUrl: 'farm-xn-dev.znlh.work' });
    if (!res) {
      throw new Error('请求失败');
    }
    // eslint-disable-next-line no-underscore-dangle
    const _res = JSON.parse(JSON.stringify(res));
    // eslint-disable-next-line no-restricted-syntax
    for (const key in _res) {
      if (['appHomeLogo', 'appHomeLogoSmall', 'appLoginLogo', 'appHomeIcon', 'appLoginBackPic'].includes(key)) {
        if (_res[key]) {
          // eslint-disable-next-line no-param-reassign
          _res[key] = getAbsolutePathIfExists(JSON.parse(_res[key]));
        }
      }
    }
    // eslint-disable-next-line no-unused-expressions
    _res.appLoginTitle ? document.title = _res.appLoginTitle : null;
    localStorage.setItem('uiInfo', JSON.stringify(_res));
  } catch (error) {
    if(process.env.NODE_ENV === 'development') {
      console.error('调试模式下请求无效', error);
    }else {
      console.error('初始化ui配置接口请求失败', error);
    }
  }
};

// 获取菜单页装修配置
const getUiFitment = async () => {
  localStorage.removeItem('ui_fitment');
  try {
    if(localStorage.getItem('appId') === '10016') {
      const res = await post(api.getUiApply, {});
      // const res = await get(api.getAllUiInfo, { domainUrl: 'farm-xn-dev.znlh.work' });
      if (!res) {
        throw new Error('请求失败');
      }
      const _res = res.data || {};
      for (const key in _res) {
        // 菜单栏小LOGO menuLogoSmall
        // 浏览器ICO图 browserIco
        // 数据大屏LOGO dataDashboardLogo
        // 菜单栏LOGO menuLogo
        // 导航背景色 navigationBackColor
        // 主题色 themeColor
        if (['menuLogoSmall', 'browserIco', 'dataDashboardLogo', 'menuLogo'].includes(key)) {
          if (_res[key]) {
            _res[key] = getAbsolutePathIfExists(JSON.parse(_res[key]));
          }
        }
      }
      if (_res.homeTitle) {
        document.title = _res.homeTitle;
      }
      localStorage.setItem('ui_fitment', JSON.stringify(_res));
      }

  } catch (error) {
    console.error('初始化主页装修配置接口请求失败', error);
  }
};
// eslint-disable-next-line import/prefer-default-export
export { getDisposition, getUiFitment };
